import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Calendar, MapPin } from "lucide-react";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function EventDetail() {
  const { slug } = useParams();
  const { data: event, isLoading } = useQuery({ queryKey: ["event", slug], queryFn: async () => (await api.get(`/events/${slug}`)).data });

  if (isLoading) return <div className="px-8 py-20 text-muted-foreground">Loading…</div>;
  if (!event) return <div className="px-8 py-20" data-testid="event-not-found">Event not found. <Link to="/events" className="underline">All events</Link></div>;

  return (
    <div data-testid="event-detail-page">
      <Seo title={`${event.title} — The Hoodie Project®`} description={event.description} />
      <section className="relative border-b border-border">
        <img src={event.image} alt={event.title} className="h-[60vh] w-full object-cover opacity-60" />
        <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black via-black/40 to-transparent px-5 py-12 md:px-12">
          {event.partner && <span className="mb-3 w-fit bg-white px-3 py-1 text-xs font-bold tracking-widest text-black">IN PARTNERSHIP WITH {event.partner.toUpperCase()}</span>}
          <h1 className="max-w-4xl font-display text-5xl font-extrabold leading-none tracking-tighter md:text-7xl">{event.title}</h1>
        </div>
      </section>

      <section className="mx-auto max-w-[900px] px-5 py-16 md:px-8">
        <div className="mb-10 flex flex-wrap gap-6 border-b border-border pb-8 text-sm text-muted-foreground">
          <span className="flex items-center gap-2"><Calendar className="h-4 w-4" /> {event.date}</span>
          <span className="flex items-center gap-2"><MapPin className="h-4 w-4" /> {event.location}</span>
        </div>
        <p className="text-lg leading-relaxed">{event.description}</p>
        <Link to="/market" className="mt-12 inline-block bg-white px-8 py-4 text-xs font-bold tracking-[0.2em] text-black hover:bg-neutral-300">SHOP THE RESALE MARKET</Link>
      </section>
    </div>
  );
}
